module.exports = __webpack_public_path__ + "img/HFIG-600-timedomain.c9e9d5bb158572707c4b2dc8d384692c.avif";